import { createFileRoute, redirect } from "@tanstack/react-router";
import CardDetailWrapper from "@/components/CardDetailWrapper";
import { loadCardPage, unresolvedMeta, SITE_ORIGIN } from "@/lib/routeSeo";

export const Route = createFileRoute("/kreditkarten/$slug")({
  loader: async ({ params }) => {
    const result = await loadCardPage(params.slug);
    if (result.redirectSlug) {
      throw redirect({
        to: "/kreditkarten/$slug",
        params: { slug: result.redirectSlug },
        statusCode: 301,
      });
    }
    return result;
  },
  head: ({ params, loaderData }) => {
    if (!loaderData?.seo) return { meta: unresolvedMeta };
    const url = `${SITE_ORIGIN}/kreditkarten/${params.slug}`;
    const { title, description, image, issuer, annualFee, updatedAt } = loaderData.seo;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "product" },
        { property: "og:url", content: url },
        ...(image ? [{ property: "og:image", content: image }] : []),
        ...(issuer ? [{ property: "product:brand", content: issuer }] : []),
        ...(typeof annualFee === "number"
          ? [
              { property: "product:price:amount", content: String(annualFee) },
              { property: "product:price:currency", content: "EUR" },
            ]
          : []),
        ...(updatedAt ? [{ property: "og:updated_time", content: updatedAt }] : []),
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        ...(image ? [{ name: "twitter:image", content: image }] : []),
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: title,
            description,
            ...(image ? { image } : {}),
            ...(issuer ? { brand: { "@type": "Organization", name: issuer } } : {}),
            url,
          }),
        },
      ],
    };
  },
  component: CardDetailWrapper,
});
